import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Punaises de lit",
    desc: "Traitement à la vapeur sèche 180 °C ou insecticide homologué, protocole en 3 passages, garantie de résultat. Matelas, sommiers, plinthes, tissus.",
  },
  {
    title: "Cafards et blattes",
    desc: "Désinsectisation professionnelle par gel appâts et pulvérisation ciblée. Cuisines, restaurants, gîtes, appartements. Traitement des points d'entrée.",
  },
  {
    title: "Fourmis",
    desc: "Traitement des fourmilières et des trajets, gel appâts intelligent. Solution durable qui élimine la reine et empêche la re-colonisation.",
  },
  {
    title: "Puces et acariens",
    desc: "Traitement complet des habitats (moquettes, canapés, tapis, animaux). Combinaison vapeur haute température et insecticide.",
  },
  {
    title: "Guêpes et frelons",
    desc: "Destruction sécurisée des nids par perche télescopique et combinaison intégrale. Frelons européens, frelons asiatiques, guêpes communes.",
  },
  {
    title: "Mouches, moucherons",
    desc: "Traitement des sources (déchets, décomposition, humidité) et pulvérisation ciblée. Adapté aux exploitations agricoles et gîtes.",
  },
  {
    title: "Vrillettes du bois et insectes xylophages",
    desc: "Traitement curatif de charpentes, poutres, parquets et meubles anciens contre vrillettes, capricornes et autres xylophages. Injection sous pression et pulvérisation homologuées.",
  },
];

const METHOD = [
  { title: "Diagnostic", desc: "Identification précise de l'espèce, évaluation de l'infestation, repérage des points d'entrée." },
  { title: "Devis clair", desc: "Devis gratuit détaillé, sans surprise. Certibiocide garantit un traitement conforme aux normes." },
  { title: "Traitement", desc: "Application ciblée : vapeur sèche, gel appâts, pulvérisation biocide selon la cible et la sensibilité du site." },
  { title: "Suivi", desc: "Contrôle 15 jours après pour vérifier l'efficacité. Si nécessaire, passage complémentaire inclus." },
];

const FAQ = [
  {
    q: "Qu'est-ce que la désinsectisation exactement ?",
    a: "La désinsectisation est l'ensemble des opérations professionnelles visant à éliminer les insectes nuisibles (punaises de lit, cafards, fourmis, puces, mouches, guêpes, frelons…) d'un lieu de vie ou de travail. Elle combine identification de l'espèce, choix du produit ou de la méthode adapté (biocide, vapeur, mécanique), et suivi post-traitement.",
  },
  {
    q: "Combien coûte une désinsectisation en Creuse ?",
    a: "Le tarif dépend de la surface, du type d'insecte et de l'infestation. Comptez à partir de 90 € pour un nid de guêpes, 150-300 € pour un traitement anti-punaises de lit d'un appartement, 100-200 € pour cafards en cuisine. Devis gratuit et personnalisé après diagnostic.",
  },
  {
    q: "Faut-il quitter son logement pendant la désinsectisation ?",
    a: "Cela dépend du traitement : la vapeur sèche ne nécessite aucune éviction (méthode sans produit chimique). Un traitement biocide classique demande de quitter les pièces traitées 2-4 h, puis d'aérer. Nous vous précisons les consignes exactes avant chaque intervention.",
  },
  {
    q: "Les traitements sont-ils dangereux pour les enfants et animaux ?",
    a: "Non, si les consignes de sécurité sont respectées. Nous utilisons uniquement des produits homologués Certibiocide, appliqués aux dosages réglementaires. Les zones traitées doivent être aérées avant retour, et les animaux/enfants éloignés le temps de séchage (2-4 h généralement).",
  },
  {
    q: "Combien de temps pour éliminer les punaises de lit ?",
    a: "Un protocole complet dure environ 4 semaines : 1er traitement immédiat, 2ème passage à J+14 (pour tuer les nymphes issues des œufs), et contrôle final à J+28. L'éradication définitive est possible dès le 2ème passage dans 90 % des cas.",
  },
  {
    q: "Utilisez-vous des produits chimiques ?",
    a: "Uniquement si nécessaire. Nous privilégions la vapeur sèche (180 °C, sans produit) pour les punaises de lit, les puces et les acariens. Pour cafards, fourmis et guêpes, nous utilisons des biocides homologués aux dosages réglementaires, en application ciblée pour limiter l'impact environnemental.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre"];

export default function DesinsectisationCreuse() {
  return (
    <PestPillarLayout
      slug="desinsectisation-creuse"
      seoTitle="Désinsectisation Creuse — Punaises cafards | K'REUSE"
      seoDescription="Désinsectisation Creuse Certibiocide. Punaises de lit, cafards, fourmis, guêpes, vrillettes. Vapeur sèche, biocides homologués."
      breadcrumbLabel="Désinsectisation Creuse"
      heroBadge="Désinsectisation professionnelle · Certibiocide"
      heroTitleHtml={`Désinsectisation en <span class="font-medium text-[#1B5E20]">Creuse (23)</span>`}
      heroSubtitle="Punaises de lit, cafards, fourmis, guêpes, frelons, puces, mouches, vrillettes du bois : nous éliminons tous les insectes nuisibles avec des méthodes homologuées Certibiocide. Interventions 7j/7 pour les urgences."
      hero_h2="Une désinsectisation efficace, durable, respectueuse"
      introParagraphs={[
        "K'REUSE EXTÉRIEUR est votre spécialiste de la désinsectisation en Creuse. Que vous soyez particulier confronté à une invasion de cafards, professionnel de l'hôtellerie face aux punaises de lit, ou exploitant agricole envahi par les mouches, nous intervenons avec la méthode adaptée à chaque insecte.",
        "Nos techniciens sont certifiés Certibiocide (agrément d'État obligatoire depuis 2015 pour manipuler les biocides à titre professionnel). Nous privilégions les méthodes les moins invasives : vapeur sèche 180 °C sans produit chimique pour les punaises de lit et acariens, gel appâts intelligents pour les cafards et fourmis, biocides homologués en application ciblée pour les guêpes et frelons.",
        "Notre force : un diagnostic gratuit qui identifie précisément l'espèce et l'ampleur de l'infestation, un devis clair sans coût caché, et un suivi post-traitement pour garantir l'éradication. Interventions à Guéret, Aubusson, La Souterraine, Bourganeuf et toute la Creuse.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      ctaTitle="Insectes nuisibles chez vous ? Agissons."
      whatsappText="Bonjour, je souhaite un devis pour une désinsectisation en Creuse."
    />
  );
}
